import { call, put, takeEvery } from "redux-saga/effects";
import { get, noop } from "lodash-es";
import {
  fetch_campaigns,
  fetch_referee_list,
  fetch_tnc_points,
  fetch_wallet_balance,
  fetch_wallet_transactions,
} from "../../apis/referAndEarn";
import {
  getActiveCampaigns,
  getRefereeList,
  getWalletBalance,
  getWalletTransactions,
  getTnc,
  setActiveCampaigns,
  setRefereeList,
  setTnc,
  setWalletBalance,
  setWalletTransactions,
} from "../reducers/referAndEarn";
import { setError } from "../reducers/error";
import { setLoader } from "../reducers/loader";

export default function* handleReferAndEarnSagas() {
  yield takeEvery(getActiveCampaigns.toString(), handleFetchCampaigns);
  yield takeEvery(getRefereeList.toString(), handleFetchRefreeList);
  yield takeEvery(
    getWalletTransactions.toString(),
    handleFetchWalletTransactions
  );
  yield takeEvery(getWalletBalance.toString(), handleFetchWalletBalance);
  yield takeEvery(getTnc.toString(), handleFetchTncPoints);
}

function* handleFetchCampaigns({ payload }) {
  const { Api, token = "", screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const campaigns = yield call(fetch_campaigns, Api, token);
    const data = get(campaigns, "result", []);
    const title = get(campaigns, "title", "");
    const shareMessage = get(campaigns, "share_message", "");
    yield put(setActiveCampaigns({ title, shareMessage, data }));
    yield call(sagaCallback, data);
  } catch (err) {
    console.error("error inside handleFetchCampaigns is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchRefreeList({ payload }) {
  const { Api, token = "", screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const response = yield call(fetch_referee_list, Api, token);
    const result = get(response, "result", []);
    yield put(setRefereeList(result));
    yield call(sagaCallback, result);
  } catch (err) {
    console.error("error inside handleFetchRefreeList is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchWalletTransactions({ payload }) {
  const { Api, token = "", screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const response = yield call(fetch_wallet_transactions, Api, token);
    const result = get(response, "transactions", []);
    yield put(setWalletTransactions(result));
    yield call(sagaCallback, result);
  } catch (err) {
    console.error("error inside handleFetchWalletTransactions is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchWalletBalance({ payload }) {
  const { Api, token = "", screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const response = yield call(fetch_wallet_balance, Api, token);
    yield put(setWalletBalance(response));
    yield call(sagaCallback, response);
  } catch (err) {
    console.error("error inside handleFetchWalletBalance is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchTncPoints({ payload }) {
  const { Api, token = "", screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const response = yield call(fetch_tnc_points, Api, token);
    const result = get(response, "result", []);
    yield put(setTnc(result));
    yield call(sagaCallback, result);
  } catch (err) {
    console.error("error inside handleFetchTncPoints is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}
